import { makeStyles } from '@material-ui/core/styles';

export const useFiltersStyles = makeStyles(
  theme => ({
    filtersWrapper: {
      padding: theme.spacing(2),
      backgroundColor: theme.palette.background.paper,
      '& hr': {
        margin: theme.spacing(2, 0)
      },
      '& hr:last-of-type': { display: 'none' }
    },
    footerButtonsContainer: {
      display: 'flex',
      position: 'sticky',
      flexDirection: 'column',
      padding: theme.spacing(2),
      gap: theme.spacing(1),
      bottom: 0,
      backgroundColor: theme.palette.background.paper
    },
    savedSearchActionsContainer: {
      marginTop: theme.spacing(1)
    },
    filtersContainer: {
      position: 'relative'
    }
  }),
  { name: 'Filters' }
);
